import { WalletTypeExtended } from "@/context/types";
import { useState, useEffect } from "react";

export const useInstalledWallets = () => {
  const [installedWallets, setInstalledWallets] = useState<WalletTypeExtended[]>([]);

  useEffect(() => {
    const checkInstalledWallets = () => {
      const installed = Object.values(WalletTypeExtended).filter((walletType) => {
        switch (walletType) {
          case WalletTypeExtended.Xverse:
            return !!(window as any).XverseProviders;
          case WalletTypeExtended.Unisat:
            return !!(window as any).unisat;
          case WalletTypeExtended.Leather:
            return !!(window as any).LeatherProvider;
          case WalletTypeExtended.Metamask:
            return !!(window as any).ethereum;
          // case WalletTypeExtended.MagicEden:
          //   return !!(window as any).magicEden?.bitcoin;
          default:
            return false;
        }
      });
      setInstalledWallets(installed);
    };

    checkInstalledWallets();
  }, []);

  return installedWallets;
};
